import React, { useState, useEffect } from 'react';

interface IFullRecordProps {
  setShowFullRecord: any;
  showFullRecord: any;
}

const FullRecord: React.FC<IFullRecordProps> = ({
  setShowFullRecord,
  showFullRecord,
}) => {
  const [ title, setTitle ] = useState<any>({ isLoading: true, data: '' });

  const checkURL = (url: string) => {
    let isValid = false;
    if (url.includes('http://')) {
      isValid = true;
    }
    if (url.includes('https://')) {
      isValid = true;
    }
    if (url.includes('www.')) {
      isValid = true;
    }
    return isValid;
  };

  const handleCloseFullRecord = () => {
    setShowFullRecord({ show: false, record: {} });
  };

  const getTitle = () => {
    if (showFullRecord?.record?._source['Name of Entity']) {
      setTitle({
        isLoading: false,
        data: showFullRecord?.record?._source['Name of Entity'],
      });
    }
    if (showFullRecord?.record?._source['Product Name']) {
      setTitle({
        isLoading: false,
        data: showFullRecord?.record?._source['Product Name'],
      });
    }
    if (showFullRecord?.record?._source['Vendor Project']) {
      setTitle({
        isLoading: false,
        data: showFullRecord?.record?._source['Vendor Project'],
      });
    }
    if (showFullRecord?.record?._source['CVE ID']) {
      setTitle({
        isLoading: false,
        data: showFullRecord?.record?._source['CVE ID'],
      });
    }
  };

  const processString = (longString: string, term?: string) => {
    const words = longString.trim().split(/\s+/);
    if (words.length >= 200) {
      if (term && longString.includes(term)) {
        return term;
      }
      return `${words.slice(0, 200).join(' ')} ...`;
    }
    return longString;
  };

  useEffect(() => {
    getTitle();
  }, []);

  return (
    <div className='full-record-container'>
      <div className='full-record-header'>
        <div className='full-record-header-content'>
          <div className='full-record-header-icon'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
            >
              <path
                d='M6 12H18M3 6H21M9 18H15'
                stroke='#4895EF'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </div>
          <div className='full-record-header-text-group'>
            <div className='full-record-header-title'>
              {title.data ? title.data : 'N/A'}
            </div>
          </div>
        </div>
        <div className='full-record-close-btn' onClick={() => handleCloseFullRecord()}>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
            <path d='M18 6L6 18M6 6L18 18' stroke='var(--card-text)' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
          </svg>
        </div>
      </div>
      <div className='full-record-body'>
        <div className='full-record-content'>
          {Object.keys(showFullRecord?.record?._source).map(
            (row: any, i: number) => (
              <div className='full-record-row' key={i}>
                <div className='full-record-row-inner'>
                  <div className='full-record-row-text-group'>
                    <div className='full-record-key'>{row}</div>
                    <div className='full-record-value'>
                      {typeof showFullRecord?.record?._source[row] ===
                      'string' ? (
                          <div className='full-record-value'>
                            {showFullRecord.record.matched_queries ?
                              processString(
                                showFullRecord?.record?._source[row],
                                showFullRecord?.record?.matched_queries[0],
                              )
                                .split(' ')
                                .map((word: any, index: any) => {
                                  if (word.startsWith('link:')) {
                                    const url = word.replace('link:', '');
                                    return checkURL(url) ? (
                                      <span key={index}>
                                        link:{' '}
                                        <a
                                          href={url}
                                          target='_blank'
                                          rel='noreferrer'
                                          className='link'
                                        >
                                          {url}
                                        </a>
                                      </span>
                                    ) : (
                                      word
                                    );
                                  }
                                  return checkURL(word) ? (
                                    <a
                                      key={index}
                                      href={word}
                                      target='_blank'
                                      rel='noreferrer'
                                      className='link'
                                    >
                                      {word}
                                    </a>
                                  ) : (
                                    word
                                  );
                                })
                                .reduce((prev: any, curr: any) => [
                                  prev,
                                  ' ',
                                  curr,
                                ]) :
                              processString(
                                showFullRecord?.record?._source[row],
                              )
                                .split(' ')
                                .map((word: any, index: any) => {
                                  if (word.startsWith('link:')) {
                                    const url = word.replace('link:', '');
                                    return checkURL(url) ? (
                                      <span key={index}>
                                        link:{' '}
                                        <a
                                          href={url}
                                          target='_blank'
                                          rel='noreferrer'
                                          className='link'
                                        >
                                          {url}
                                        </a>
                                      </span>
                                    ) : (
                                      word
                                    );
                                  }
                                  return checkURL(word) ? (
                                    <a
                                      key={index}
                                      href={word}
                                      target='_blank'
                                      rel='noreferrer'
                                      className='link'
                                    >
                                      {word}
                                    </a>
                                  ) : (
                                    word
                                  );
                                })
                                .reduce((prev: any, curr: any) => [
                                  prev,
                                  ' ',
                                  curr,
                                ])}
                          </div>
                        ) : (
                          <div className='full-record-value'>
                            {showFullRecord?.record?._source[row]}
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            ),
          )}
        </div>
      </div>
    </div>
  );
};

export default FullRecord;
